import { render } from "./portfolioItem.vue?vue&type=template&id=b2e15018"
import script from "./portfolioItem.vue?vue&type=script&lang=js"
export * from "./portfolioItem.vue?vue&type=script&lang=js"

import "./portfolioItem.vue?vue&type=style&index=0&id=b2e15018&lang=css"

import exportComponent from "/var/www/prod.storm.ms/actions-runner/storm-site/storm-site/storm-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__